// extracted by mini-css-extract-plugin
export default {"containerList":"ReviewList_containerList__7e8JO","show":"ReviewList_show__JMDgm","button_click":"ReviewList_button_click__Ah6ms"};